<script setup lang="ts">
import type { AtomsGiantShortcutProps } from './AtomsGiantShortcut.props'

const localePath = useLocalePath()

defineProps<AtomsGiantShortcutProps>()
</script>

<template>
  <NuxtLink
    :to="link && !disabled ? localePath(link) : ''"
    class="py-lg md:py-4xl md:gap-y-md flex w-full flex-col items-center gap-y-3"
    active-class="[&>svg]:text-primitives-grey-200 [&>span]:text-primitives-grey-200 border-b border-b-neutral-black"
    :class="[
      disabled
        ? 'bg-primitives-off-white pointer-events-none cursor-default opacity-20'
        : 'bg-neutral-white focus-within:text-primitives-grey-200 hover:bg-primitives-off-white [&:hover>span]:no-underline',
    ]"
    :aria-disabled="disabled"
  >
    <slot name="icon" />

    <slot name="text">
      <span
        class="text-link-6 md:text-link-5"
        :class="[disabled ? 'no-underline' : 'underline']"
      >
        {{ text }}
      </span>
    </slot>
  </NuxtLink>
</template>
